









































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { AgencySettingsModule } from "@/store/modules/agencySettings";
import { AgencyScheduleModule } from "@/store/modules/agencySchedule";

@Component({
  name: "JobScheduleSearchCriteria",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  public locationSearch: any = null;
  public datesFailedValidation = false;

  get searchOptions() {
    return AgencyScheduleModule.filterJobScheduleViewModel;
  }
  get currentSearchCriteria() {
    return AgencyScheduleModule.currentJobScheduleSearchCriteria;
  }

  get weekCommencing() {
    const dateStr = AgencyScheduleModule.currentJobScheduleSearchCriteria.from;
    const dArr = dateStr.split("-");  // ex input "2010-01-18"
    return dArr[2]+ "/" +dArr[1]+ "/" +dArr[0].substring(2); //ex out: "18/01/10"
  }

  get desks() {
    if (this.searchOptions.selectedBranch !== null && this.searchOptions.selectedBranch !== undefined) {
      return this.searchOptions.selectedBranch.desks;
    }
      return [];
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get loading() {
    return AgencyScheduleModule.loading;
  }

  allowedDates(date: Date) {
    return new Date(date).getDay() === 1;
  }

  async search() {
    if (AgencyScheduleModule.filterJobScheduleViewModel.from === undefined) {
      this.datesFailedValidation = true;
      return;
    }
    this.dialog = false;
    await AgencyScheduleModule.getJobSchedule();
  }
}
